export default function($) {

  $(document).ready(function() {
    // Keep '.js-tarteaucitron-panel' class name for legacy
    $('.js-tarteaucitron-panel, .js-cookies-panel').on('click', function (e) {
      e.preventDefault();
      return klaro.show();
    });

  });
}
